const MenuInicio = {
    Nombre: "Inicio",
    Icono: "fas fa-home",
    Permiso: 'CLAVEINICIO',
    Router: "inicio",
    Parametros: {sFiltros:'NO'},
    TipoBoton: 0,
    EsDeRoot: 0,
    SubMenus:[]
}

const MenuCotizacion = {
    Nombre: "Cotizacion",
    Icono: "fas fa-file-invoice",
    Permiso: 'CLAVECOTIZACION',
    Router: "cotizaciones",
    Parametros: {sFiltros:'NO',pOrigen:'Cotizaciones'},
    TipoBoton: 0,
    EsDeRoot: 0,
    SubMenus: [],
};

const MenuGestion = {
    Nombre: "Gestion",
    Icono: "fas fa-cubes",
    Permiso: 'CLAVEGESTION',
    Router: "",
    Parametros: {sFiltros:'NO'},
    TipoBoton: 0,
    EsDeRoot: 0,
    SubMenus: [
        {  
            Nombre: 'Pedidos',
            Icono: "",
            Permiso: 'CLAVEPEDIDOS',
            Router: 'pedidos',
            Parametros: {sFiltros:'NO',pOrigen:'Pedidos'},
            TipoBoton: 0,
            EsDeRoot: 0,
            Apartados:[]
        },
        {  
            Nombre: 'Garantias',
            Icono: "",
            Permiso: 'CLAVEGARANTIAS',
            Router: 'garantias',
            Parametros: {sFiltros:'NO',pOrigen:'Garantias'},
            TipoBoton: 0,
            EsDeRoot: 0,
            Apartados:[]
        },
        {  
            Nombre: 'Paquetes',
            Icono: "",
            Permiso: 'CLAVEPAQUETES',
            Router: 'envios',
            Parametros: {sFiltros:'NO'},
            TipoBoton: 0,
            EsDeRoot: 0,
            Apartados:[]
        },
    ],
};


const MenuCargosCliente = {
    Nombre: "Cargos Cliente",
    Icono: "fas fa-file-invoice-dollar",
    Permiso: 'CLAVECARGOCLIENTE',
    Router: "cargoscliente",
    Parametros: {sFiltros:'NO'},
    TipoBoton: 0,
    EsDeRoot: 0,
    SubMenus:[]
}

const MenuPagos = {
    Nombre: "Pagos Realizados",
    Icono: "fas fa-sack-dollar",
    Permiso: 'CLAVEPAGOSREALIZADOS',
    Router: "pagosrealizados",
    Parametros: {sFiltros:'NO'},
    TipoBoton: 0,
    EsDeRoot: 0,
    SubMenus:[]
}

const MenuAdmin = {
    Nombre: 'Administracion',
    Icono: 'fas fa-cogs',
    Permiso: 'CLAVEADMINISTRACION',
    Router: '',
    Parametros: {sFiltros:'NO'},
    TipoBoton: 0,
    EsDeRoot: 0,
    SubMenus: [
        {  
            Nombre: 'Conf. Lentes',
            Icono: "",
            Permiso: 'CLAVECONFIGLENTES',
            Router: 'TipoFamiliar',
            Parametros: {sFiltros:'NO'},
            TipoBoton: 1,
            EsDeRoot: 0,
            Apartados:[
                {
                    Nombre: "Tinte",
                    Icono: "fas fa-tint",
                    Permiso: 'CLAVETINTE',
                    Router: "tintes",
                    Parametros: {sFiltros:'NO'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    Apartados: [],
                },
                {
                    Nombre: "Materiales",
                    Icono: "fas fa-tools",
                    Permiso: 'CLAVEMATERIALES',
                    Router: "materiales",
                    Parametros: {sFiltros:'NO'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    Apartados: [],
                },
                {
                    Nombre: "Sub linea",
                    Icono: "fas fa-globe",
                    Permiso: 'CLAVESUBLINEA',
                    Router: "sublineas",
                    Parametros: {sFiltros:'NO'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    Apartados: [],
                },
                {
                    Nombre: "Bisel",
                    Icono: "far fa-border-style-alt",
                    Permiso: 'CLAVEBISEL',
                    Router: "biseles",
                    Parametros: {sFiltros:'NO'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    Apartados: [],
                },
                {
                    Nombre: "Armazón",
                    Icono: "fas fa-glasses",
                    Permiso: 'CLAVEARMAZON',
                    Router: "armazones",
                    Parametros: {sFiltros:'NO'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    Apartados: [],
                },
                {
                    Nombre: "Protección",
                    Icono: "fas fa-shield-alt",
                    Permiso: 'CLAVEPROTECCION',
                    Router: "protecciones",
                    Parametros: {sFiltros:'NO'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    Apartados: [],
                },
                {
                    Nombre: "Recubrimiento",
                    Icono: "fas fa-layer-group",
                    Permiso: 'CLAVERECUBRIMIENTO',
                    Router: "recubrimientos",
                    Parametros: {sFiltros:'NO'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    Apartados: [],
                },
                {
                    Nombre: "Color",
                    Icono: "fas fa-palette",
                    Permiso: 'CLAVECOLOR',
                    Router: "colores",
                    Parametros: {sFiltros:'NO'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    Apartados: [],
                },
            ]
        },
        {
            Nombre: 'Conf. Rangos',
            Icono: "",
            Permiso: 'CLAVECONFIGRANGOS',
            Router: 'TipoFamiliar',
            Parametros: {sFiltros:'NO'},
            TipoBoton: 1,
            EsDeRoot: 0,
            Apartados:[
                {
                    Nombre: 'Rango esfera',
                    Icono: "fas fa-circle",
                    Permiso: 'CLAVERANGOCILINDRO',
                    Router: 'rangosesferas',
                    Parametros: {sFiltros:'NO',pOrigen:'Finanzas'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    SubApartados: []
                },
                {
                    Nombre: 'Rango cilindro',
                    Icono: "fas fa-flask",
                    Permiso: 'CLAVERANGOCILINDRO',
                    Router: 'rangoscilindros',
                    Parametros: {sFiltros:'NO',pOrigen:'Finanzas'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    SubApartados: []
                },
                {
                    Nombre: 'Rango adicional',
                    Icono: "fas fa-ruler",
                    Permiso: 'CLAVERANGOADICIONAL',
                    Router: 'rangosadicionales',
                    Parametros: {sFiltros:'NO',pOrigen:'Finanzas'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    SubApartados: []
                },
            ]
        },

        {
            Nombre: 'Articulos',
            Icono: "",
            Permiso: 'CLAVEARTICULOS',
            Router: 'TipoFamiliar',
            Parametros: {sFiltros:'NO'},
            TipoBoton: 1,
            EsDeRoot: 0,
            Apartados: [
                {
                    Nombre: 'Tipo de lentes',
                    Icono: "fas fa-glasses",
                    Permiso: 'CLAVETIPODELENTE',
                    Router: 'tiposlentes',
                    Parametros: {sFiltros:'NO'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    SubApartados: []
                },
                {
                    Nombre: 'Articulos',
                    Icono: "far fa-box-full",
                    Permiso: 'CLAVEARTARTICULOS',
                    Router: 'articulos',
                    Parametros: {sFiltros:'NO'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    SubApartados: []
                },
              
            ]
        },

        {
            Nombre: 'Conf. Paquetes',
            Icono: "",
            Permiso: 'CLAVECONFIGPAQUETES',
            Router: 'TipoFamiliar',
            Parametros: {sFiltros:'NO'},
            TipoBoton: 1,
            EsDeRoot: 0,
            Apartados: [
                {
                    Nombre: "Paqueterias",
                    Icono: "fas fa-truck",
                    Permiso: 'CLAVEPAQUETERIAS',
                    Router: "paqueterias",
                    Parametros: {sFiltros:'NO'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    Apartados: [],
                },
                {
                    Nombre: "Garantía de entregas",
                    Icono: "fas fa-shield-check",
                    Permiso: 'CLAVEGARANTIAENTREGAS',
                    Router: "fechaspaquetes",
                    Parametros: {sFiltros:'NO'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    Apartados: [],
                },
                
            ]
        },

        {
            Nombre: 'Estatus Pedido',
            Icono: "",
            Permiso: 'CLAVEESTATUSPEDIDOS',
            Router: 'catasestatus',
            Parametros: {sFiltros:'NO'},
            TipoBoton: 0,
            EsDeRoot: 0,
            Apartados: []
        }
    ]
};

const MenuSeguridad = {
    Nombre: 'Seguridad',
    Icono: 'fas fa-shield-alt',
    Permiso: 'CLAVESEGURIDAD',
    Router: 'panelSubMenus',
    Parametros: {sFiltros:'NO'},
    TipoBoton: 0,
    EsDeRoot: 0,
    SubMenus: [
        {
            Nombre: 'Perfil',
            Icono: "fas fa-money-check-edit",
            Permiso: 'CLAVEPERFIL',
            Router: 'perfiles',
            Parametros: {sFiltros:'NO'},
            TipoBoton: 0,
            EsDeRoot: 0,
            Apartados: []
        },
        {
            Nombre: 'Clientes',
            Icono: "fas fa-money-check-edit",
            Permiso: 'CLAVECLIENTES',
            Router: 'clientes',
            Parametros: {sFiltros:'NO'},
            TipoBoton: 0,
            EsDeRoot: 0,
            Apartados: []
        },
        {
            Nombre: 'Usuarios',
            Icono: "fas fa-money-check-edit",
            Permiso: 'CLAVEUSUARIOS',
            Router: 'usuarios',
            Parametros: {sFiltros:'NO',pOrigen:'Menu'},
            TipoBoton: 0,
            EsDeRoot: 0,
            Apartados: []
        },
        {
            Nombre: 'Folios',
            Icono: "fas fa-money-check-edit",
            Permiso: 'CLAVEFOLIOS',
            Router: 'folios',
            Parametros: {sFiltros:'NO'},
            TipoBoton: 0,
            EsDeRoot: 0,
            Apartados: []
        },
        {
            Nombre: 'Correos pedidos',
            Icono: "fas fa-money-check-edit",
            Permiso: 'CLAVECORREOPEDIDOS',
            Router: 'envios',
            Parametros: {sFiltros:'NO'},
            TipoBoton: 0,
            EsDeRoot: 0,
            Apartados: []
        },
        {
            Nombre: 'Menus',
            Icono: "far fa-bars",
            Permiso: 'CLAVEMENUS',
            Router: 'paneles',
            Parametros: {sFiltros:'NO',},
            TipoBoton: 0,
            EsDeRoot: 1,
            SubApartados: []
        },
        {
            Nombre: 'Permisos',
            Icono: "fas fa-user-lock",
            Permiso: 'CLAVEPERMISOS',
            Router: 'permisos',
            Parametros: {sFiltros:'NO',},
            TipoBoton: 0,
            EsDeRoot: 1,
            SubApartados: []
        },
    ]
};

const MenuConfDatos =
{
    Nombre: 'Import. Datos',
    Icono: 'fas fa-file-upload',
    Permiso: 'CLAVEIMPORTDATOS',
    Router: '',
    Parametros: {sFiltros:'NO'},
    TipoBoton: 0,
    EsDeRoot: 0,
    SubMenus: [
        {
            Nombre: 'Importar config. articulos web',
            Icono: "fas fa-file-excel",
            Permiso: 'CLAVEIMPORTCAW',
            Router: 'panelSubMenus',
            Parametros: {},
            TipoBoton: 1,
            EsDeRoot: 0,
            Apartados:[]
        },
        {
            Nombre: 'Importar articulos microsip',
            Icono: "fas fa-file-excel",
            Permiso: 'CLAVEIMPORTAM',
            Router: 'panelSubMenus',
            Parametros: {},
            TipoBoton: 1,
            EsDeRoot: 0,
            Apartados:[]
        },
        {
            Nombre: 'Importar cliente microsip',
            Icono: "fas fa-file-excel",
            Permiso: 'CLAVEIMPORTCM',
            Router: 'panelSubMenus',
            Parametros: {},
            TipoBoton: 1,
            EsDeRoot: 0,
            Apartados:[]
        },        
    ]
};

const ConfigMenus = [
    MenuInicio,
    MenuCotizacion,
    MenuGestion,
    MenuCargosCliente,
    MenuPagos,

    MenuAdmin,
    MenuSeguridad,
    MenuConfDatos
];

export default {
    ConfigMenus,
}
